import { ROW_HEIGHTS as p, HEADER_HEIGHTS as i } from "./index.es594.js";
const E = (f, h, r, l = 3, n = 20) => {
  let t = l;
  if (r) {
    const e = p[h], o = i[h], s = (typeof r == "string" ? parseInt(r.replace("px", ""), 10) : r) - o - 40;
    t = Math.floor(s / e), t = Math.max(l, Math.min(n, t));
  }
  const a = [];
  for (let e = 0; e < t; e++) {
    const o = {};
    o.id = `placeholder-${e}`, f.forEach((c) => {
      c.field && (o[c.field] = null);
    }), a.push(o);
  }
  return a;
};
export {
  E as generatePlaceholderRows
};
//# sourceMappingURL=index.es598.js.map
